import type { Transactable } from '@src/domains/transactables/types/transactable';

// Only one of the entities is what is actually being paid, and the first match wins. The sale
// change comes first because it is its own charge riding on an order that may well have been
// confirmed by the original purchase. The direct link has no `isPayable`, so expiry answers for it.
//
// Nothing to pay is not payable — and not expired either, which is a distinction the callers draw.
export const isTransactablePayable = (tr: Transactable): boolean => {
  if (tr.saleChange) {
    return tr.saleChange.isPayable;
  }

  if (tr.order) {
    return tr.order.isPayable;
  }

  if (tr.sale) {
    return tr.sale.isPayable;
  }

  if (tr.directLink) {
    return !tr.directLink.isExpired;
  }

  return false;
};
